import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from '../../apiService/allApi';
import "../css/base.css"; // Ensure you create this CSS file
import { RiShieldUserLine } from "react-icons/ri";
import { BsFacebook } from "react-icons/bs";
import OtpInput from "react-otp-input";


export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const { referralcode } = useParams();

  const [Phone, setPhone] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
  const [isValid, setIsValid] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const [showSplash, setShowSplash] = useState(true);
  const referral = referralcode || location.pathname.split("/")[2] || "";


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    let timerInterval;
    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    } else {
      clearInterval(timerInterval);
      setIsValid(false);
    }
    return () => clearInterval(timerInterval);
  }, [isValid, seconds]);

  const handleClick = async (e) => {
    if (e) e.preventDefault();
    if (!Phone || Phone.length !== 10) {
      return Swal.fire({ icon: "error", title: "Oops...", text: "Please enter correct phone number" });
    }
    setIsloading1(true);
    const respone = await apiRequest('login', "POST", { Phone, referral });
    setIsloading1(false);
    if (respone?.data?.status === 200) {
      setOtp(true);
      setIsValid(true);
      setSeconds(60);
      setSecretCode(respone?.data?.secret);
      if (respone?.data?.myToken) {
        Swal.fire({ icon: "success", title: "OTP", text: "Demo OTP: " + respone?.data?.myToken });
      }
    } else {
      Swal.fire({ icon: "error", title: "Oops...", text: respone?.data?.msg || "Login failed" });
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();
    setIsloading1(true);
    try {
      const response = await apiRequest(`login/finish`, "POST", { Phone, twofactor_code, referral, secretCode });
      setIsloading1(false);
      if (response?.data?.status === 200) {
        localStorage.setItem("token", response?.data?.token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        Swal.fire({ icon: "error", title: "Oops...", text: response?.data?.msg || "Something went wrong!" });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({ icon: "error", title: "Oops...", text: "Error verifying OTP" });
    }
  };
  if (showSplash) {
    return (
      <div className="splash-screen">

        <div className="splash-content">

          <img
            src="./images/splace-logo.png"
            alt=""
            className="splash-logo"
          />

          <h3 className="splash-tagline">
            🎲 Roll the Dice. Rule the Board!
          </h3>
          <div className="mlk_gold_divider">
            <span>✦</span>
          </div>

          <div className="mlk_progress_wrap">

            <span className="mlk_dice_icon">🎲</span>

            <div className="mlk_progress_bar">
              <div className="mlk_progress_fill"></div>
            </div>

            <span className="mlk_dice_icon">🎲</span>

          </div>

          <div className="mlk_slider_dots">
            <span></span>
            <span className="active"></span>
            <span></span>
          </div>

          <h4 className="loading-text">
            Shuffling snakes and ladders...
          </h4>

          <div className="mlk_gold_divider">
            <span>✦</span>
          </div>

        </div>

      </div>
    );
  }
  return (
    <div className="mlk_login_screen">

      {/* Background Glow */}
      <div className="mlk_bg_glow"></div>

      {/* Logo */}
      <div className="mlk_logo_wrap">
        <img
          src="./images/malik-ludo-logo1.png"
          alt=""
          className="mlk_logo"
        />
        <img
          src="./images/login-ludo-boards.png"
          alt=""
          className="mlk_lodo_board"
        />
      </div>
      <div>
        {/* Login Box */}
        <div className="mlk_box_outer">
          <div className="mlk_box">

            {/* Floating Header */}
            <div className="mlk_floating_title">
              <RiShieldUserLine className="icons" />
              <span>Register / Login</span>
            </div>

            <div className="mlk_box_inner">

              <form onSubmit={otp ? varifyOtp : handleClick}>

                {/* Mobile */}
                <div className="mlk_input_box">

                  <div className="mlk_flag_area">
                    <img
                      src="https://flagcdn.com/w40/in.png"
                      alt=""
                      className="mlk_flag_img"
                    />
                  </div>

                  <div className="mlk_code">
                    +91
                  </div>

                  <input
                    type="tel"
                    placeholder="Mobile number"
                    value={Phone}
                    disabled={otp}
                    onChange={(e) =>
                      setPhone(
                        e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10)
                      )
                    }
                    required
                  />
                </div>

                {otp && (
                  <div className="mlk_otp_overlay">

                    <div className="mlk_otp_popup">

                      <div
                        className="mlk_otp_close"
                        onClick={() => setOtp(false)}
                      >
                        ✕
                      </div>

                      <div className="mlk_otp_header">
                        ENTER OTP
                      </div>

                      <p className="mlk_otp_msg">
                        We have sent the verification code to your
                        mobile number
                        {/* <br /> */}
                        <span> +91 {Phone}</span>
                        <span className="mlk_check">✔</span>
                      </p>

                      <input
                        type="text"
                        maxLength={6}
                        className="mlk_hidden_otp"
                        value={twofactor_code}
                        onChange={(e) =>
                          settwofactor_code(
                            e.target.value.replace(/\D/g, "")
                          )
                        }
                        autoFocus
                      />

                      {/* <div
                        className="mlk_otp_boxes"
                        onClick={() =>
                          document
                            .querySelector(".mlk_hidden_otp")
                            ?.focus()
                        }
                      >
                        {[0, 1, 2, 3, 4, 5].map((i) => (
                          <div
                            key={i}
                            className={`mlk_digit_box ${twofactor_code.length === i ? "active" : ""
                              }`}
                          >
                            {twofactor_code[i] || ""}
                          </div>
                        ))}
                      </div> */}
                      <div className="mlk_otp_boxes">
                        <OtpInput
                          value={twofactor_code}
                          onChange={settwofactor_code}
                          numInputs={6}
                          renderInput={(props) => (
                            <input
                              {...props}
                              className="mlk_digit_box"
                              type="text"
                              inputMode="numeric"
                            />
                          )}
                        />
                      </div>

                      <div className="mlk_resend_timer">
                        {seconds > 0 ? (
                          <>
                            Resend code in <span>{seconds}s</span>
                          </>
                        ) : (
                          <span
                            className="mlk_resend_link"
                            onClick={handleClick}
                          >
                            Resend OTP
                          </span>
                        )}
                      </div>

                      <button
                        className="mlk_verify_btn"
                        onClick={varifyOtp}
                      >
                        VERIFY & LOGIN
                      </button>

                    </div>

                  </div>
                )}

                <button
                  type="submit"
                  className="mlk_continue_btn"
                  disabled={isLoading1}
                >
                  {isLoading1 ? (
                    <Spinner
                      animation="border"
                      size="sm"
                    />
                  ) : otp ? (
                    "VERIFY OTP"
                  ) : (
                    "CONTINUE"
                  )}
                </button>


                <div className="mlk_or_wrap">
                  <div className="mlk_or_line"></div>
                  <span>OR</span>
                  <div className="mlk_or_line"></div>
                </div>

                <button
                  type="button"
                  className="mlk_fb_btn"
                >
                  <BsFacebook />
                  Sign In with Facebook
                </button>

                <div className="mlk_guest_line">
                  Don't want to login?
                  <span> Play as a Guest</span>
                </div>

              </form>



            </div>



          </div>
        </div>

        <div className="mlk_terms">
          By logging in, you agree to our
          <span> Terms & Conditions</span>
        </div>
      </div>
    </div>
  );
}